import { LocaleId } from '@domgen/dgx-fe-i18n';
import { MentionMeParameters } from '../../models/mention-me/mention-me-parameters.interface';
import { MentionMeSituation } from '../../models/mention-me/mention-me-situation.enum';

export const mockMentionMeParameters: MentionMeParameters = {
  locale: LocaleId.English_GreatBritain,
  situation: MentionMeSituation.PostPurchaseMainsite,
};
